import { TokenAmount } from "../types";
import { bigIntLamportsToUiAmount } from "./math";

export function toTokenAmount(amount: bigint, decimals: number): TokenAmount {
    return { amount, decimals };
}

// Lossless TokenAmount → UI number, for the USD / ratio / chart boundary only. The amount itself
// stays a TokenAmount end-to-end; reach for this only where a value is multiplied by a float price
// or fed to a chart.
export function tokenAmountToUiNumber(amount: TokenAmount | undefined): number | undefined {
    if (!amount) return undefined;
    if (amount.amount < 0n) return -Number(bigIntLamportsToUiAmount(-amount.amount, amount.decimals));
    return Number(bigIntLamportsToUiAmount(amount.amount, amount.decimals));
}
